const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function formatCurrency(amount: number): string {
  return formatter.format(amount);
}

export function formatCents(cents: number): string {
  return formatCurrency(cents / 100);
}
